/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var OutsideClick_1 = require("./util/OutsideClick");
var Input_1 = require("./Input");
var Icon_1 = require("./Icon");
var DropdownFade_1 = require("./util/DropdownFade");
var react_transition_group_1 = require("react-transition-group");
var InputText_1 = require("./InputText");
var Select_1 = require("./Select");
/* eslint-disable no-useless-escape */
var safeRegexp = function (val) {
    return val.replace(/([\[\]\\\)\(\?\+\*\.\$\^])/g, function (match) { return "\\" + match; });
};
var defaultSearchMatch = function (searchQuery, term) {
    return term.search(new RegExp(safeRegexp(searchQuery), "i")) >= 0;
};
var KEYCODE = {
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    LEFT: 37,
    ENTER: 13,
    ESC: 27,
    SHIFT: 16,
    BACKSPACE: 8,
    TAB: 9
};
var OPTIONS_HEIGHT = 35;
var propTypes = tslib_1.__assign({ value: PropTypes.any, placeholder: PropTypes.string, className: PropTypes.string, noOptionFound: PropTypes.string.isRequired, onChange: PropTypes.func.isRequired, maxResults: PropTypes.number, maxVisibleOptions: PropTypes.number, clearable: PropTypes.bool, searchMatch: PropTypes.func.isRequired }, Input_1.Input.propTypes);
delete propTypes.type;
var SelectSearchable = /** @class */ (function (_super) {
    tslib_1.__extends(SelectSearchable, _super);
    function SelectSearchable(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            var value = e.target.value;
            _this.setState({ searchQuery: value });
        };
        /* tslint:disable-next-line */
        _this.handleKeyDown = function (e) {
            // eslint-disable-line
            var keyCode = e.keyCode;
            var newState = {
                searchQuery: _this.state.searchQuery
            };
            if (e.ctrlKey ||
                e.metaKey ||
                e.altKey ||
                keyCode === KEYCODE.LEFT ||
                keyCode === KEYCODE.RIGHT) {
                return;
            }
            var currentIndex = _this.state.focusedIndex || 0;
            var options = _this.getFilteredChildren();
            var focusedOption = options[currentIndex];
            var limit = _this.props.maxResults
                ? Math.min(_this.props.maxResults, options.length)
                : options.length;
            if (!_this.state.optionsVisible &&
                (keyCode === KEYCODE.DOWN || keyCode === KEYCODE.UP)) {
                _this.showOptions();
                return;
            }
            if (_this.props.clearable &&
                !_this.state.searchQuery &&
                keyCode === KEYCODE.BACKSPACE) {
                newState.optionsVisible = false;
                _this.props.onChange(e, undefined);
            }
            else if (keyCode === KEYCODE.ESC) {
                newState.searchQuery = "";
                newState.optionsVisible = !_this.state.optionsVisible;
            }
            else if (focusedOption &&
                (keyCode === KEYCODE.ENTER ||
                    (keyCode === KEYCODE.TAB && _this.state.optionsVisible))) {
                e.preventDefault();
                if (focusedOption.props.disabled || !_this.state.optionsVisible) {
                    return;
                }
                _this.props.onChange(e, focusedOption.props.value);
                newState.optionsVisible = false;
                newState.focusedIndex = 0;
            }
            else if (keyCode === KEYCODE.UP) {
                e.preventDefault();
                newState.focusedIndex = currentIndex <= 0 ? limit - 1 : currentIndex - 1;
            }
            else if (keyCode === KEYCODE.DOWN) {
                e.preventDefault();
                newState.focusedIndex = currentIndex >= limit - 1 ? 0 : currentIndex + 1;
            }
            else if (keyCode === KEYCODE.SHIFT) {
                // Shiftkey only pressed, no need to change any focus or visibility
            }
            else {
                newState.optionsVisible = true;
                // newState.focusedIndex = 0;
            }
            if (keyCode === KEYCODE.TAB) {
                newState.optionsVisible = false;
            }
            if (_this.listElement) {
                _this.setScrollTopOnDropdown(newState.focusedIndex || _this.state.focusedIndex || 0);
            }
            _this.setState(newState);
        };
        _this.handleOutsideClick = function () {
            _this.setState({ searchQuery: null });
            if (_this.state.optionsVisible && _this.props.onBlur) {
                _this.props.onBlur();
            }
            _this.hideOptions();
        };
        _this.handleClick = function (e) {
            _this.showOptions();
        };
        _this.handleFocus = function (e) {
            e.target.selectionStart = 0;
            e.target.selectionEnd = e.target.value.length;
            if (_this.props.onFocus) {
                _this.props.onFocus();
            }
        };
        _this.handleBlur = function (e) {
            if (!_this.state.optionsVisible) {
                _this.setState({ searchQuery: null });
                _this.hideOptions();
                if (_this.props.onBlur) {
                    _this.props.onBlur();
                }
            }
            else {
                e.preventDefault();
            }
        };
        _this.dropdownRef = function (element) {
            _this.listElement = element;
            if (_this.state.focusedIndex) {
                _this.setScrollTopOnDropdown(_this.state.focusedIndex);
            }
        };
        _this.listElement = null;
        _this.inputElement = null;
        _this.state = {
            optionsVisible: false,
            focusedIndex: 0,
            searchQuery: null
        };
        return _this;
    }
    SelectSearchable.prototype.setScrollTopOnDropdown = function (index) {
        if (this.listElement) {
            var optionElement = this.listElement.children[index];
            if (optionElement) {
                this.listElement.scrollTop =
                    index * optionElement.clientHeight -
                        this.listElement.clientHeight / 2 +
                        20;
            }
        }
    };
    SelectSearchable.prototype.hideOptions = function () {
        this.setState({ optionsVisible: false });
    };
    SelectSearchable.prototype.showOptions = function () {
        var _this = this;
        var focusedIndex = this.state.focusedIndex;
        if (this.props.value) {
            // Find index of value
            var childrenArray = React.Children.toArray(this.props.children);
            var activeOption = childrenArray.find(function (child) { return child.props.value === _this.props.value; });
            if (activeOption) {
                focusedIndex = childrenArray.indexOf(activeOption);
            }
        }
        this.setState({ focusedIndex: focusedIndex, optionsVisible: true });
    };
    SelectSearchable.prototype.componentWillReceiveProps = function () {
        if (this.state.searchQuery !== null) {
            this.setState({
                searchQuery: null
            });
        }
        if (this.state.optionsVisible) {
            this.hideOptions();
        }
    };
    SelectSearchable.prototype.getFilteredChildren = function () {
        var searchQuery = this.state.searchQuery;
        var _a = this.props, _b = _a.searchMatch, searchMatch = _b === void 0 ? defaultSearchMatch : _b, maxResults = _a.maxResults, children = _a.children;
        var childrenArray = React.Children.toArray(children);
        return childrenArray
            .filter(function (child) {
            if (searchQuery !== null && searchQuery !== undefined) {
                return searchMatch(searchQuery, child.props
                    .children);
            }
            return true;
        })
            .slice(0, maxResults || childrenArray.length);
    };
    SelectSearchable.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, onChange = _a.onChange, className = _a.className, onBlur = _a.onBlur, onFocus = _a.onFocus, maxVisibleOptions = _a.maxVisibleOptions, inputProps = tslib_1.__rest(_a, ["value", "onChange", "className", "onBlur", "onFocus", "maxVisibleOptions"]);
        var _b = this.state, searchQuery = _b.searchQuery, optionsVisible = _b.optionsVisible;
        var activeOptionChildren;
        var children = this.getFilteredChildren().map(function (child, index) {
            var castedChild = child;
            if (!castedChild) {
                return castedChild;
            }
            if (castedChild.props.value === value) {
                activeOptionChildren = castedChild.props.children;
            }
            return React.cloneElement(castedChild, {
                active: value === castedChild.props.value,
                focused: index === _this.state.focusedIndex,
                onMouseMove: function () { return _this.setState({ focusedIndex: index }); },
                onSelect: function (e) {
                    onChange(e, castedChild.props.value);
                    if (_this.inputElement) {
                        _this.inputElement.focus();
                    }
                }
            });
        });
        var inputValue = searchQuery || "";
        return (React.createElement(OutsideClick_1.OutsideClick, { onOutsideClick: this.handleOutsideClick },
            React.createElement("div", { className: classnames("m-select", className) },
                React.createElement(InputText_1.InputText, tslib_1.__assign({ inputRef: function (input) { return (_this.inputElement = input); }, inputClassName: classnames("m-select-input", !!activeOptionChildren &&
                        !searchQuery &&
                        "m-select-input-isHidden"), title: activeOptionChildren, value: inputValue, onFocus: this.handleFocus, onKeyDown: this.handleKeyDown, onClick: this.handleClick, onBlur: this.handleBlur, onChange: this.handleChange, 
                    // since some browsers ignore "off", we silence autocomplete by
                    // declaring a "new-password" input
                    autoComplete: "new-password" }, inputProps, { placeholder: !!activeOptionChildren ? "" : inputProps.placeholder }),
                    React.createElement(react_transition_group_1.TransitionGroup, null, optionsVisible && (React.createElement(DropdownFade_1.DropdownFade, { key: "options" },
                        React.createElement("div", { className: "m-select-options", ref: this.dropdownRef, style: maxVisibleOptions
                                ? {
                                    maxHeight: maxVisibleOptions * OPTIONS_HEIGHT
                                }
                                : undefined }, children.length === 0 && !!searchQuery ? (React.createElement(Select_1.SelectOption, { disabled: true }, this.props.noOptionFound)) : (children))))),
                    !!activeOptionChildren && !searchQuery && (React.createElement("span", { className: "m-select-value" }, activeOptionChildren)),
                    React.createElement(Icon_1.Icon, { type: "select", className: "m-select-chevron" })))));
    };
    SelectSearchable.propTypes = propTypes;
    SelectSearchable.defaultProps = {
        searchMatch: defaultSearchMatch
    };
    return SelectSearchable;
}(React.Component));
exports.SelectSearchable = SelectSearchable;